// สถานะการจัดส่ง - ต้องตรงกับ misumi-api/helpers/constans/shipping.js เสมอ
//
// '9' (ไม่ระบุ) ใช้กับข้อมูลที่มีอยู่ก่อนเปิดใช้ระบบติดตามการจัดส่ง
// ตั้งเองไม่ได้ (backend reject) แต่เปลี่ยนออกจากมันได้ - ประตูทางเดียว
export const SHIPPING_STATUS = {
  PENDING: '1',
  IN_TRANSIT: '2',
  DELIVERED: '3',
  FAILED: '4',
  CANCELLED: '5',
  LEGACY: '9',
};

export const SHIPPING_STATUS_LABEL = {
  '1': 'รอดำเนินการจัดส่ง',
  '2': 'อยู่ระหว่างจัดส่ง',
  '3': 'จัดส่งสำเร็จ',
  '4': 'จัดส่งไม่สำเร็จ',
  '5': 'ยกเลิก',
  '9': 'ไม่ระบุ (ก่อนใช้ระบบ)',
};

// ⚠️ อย่าใช้สองลิสต์นี้สลับกัน
// SETTABLE = ตัวเลือกที่ให้ผู้ใช้เลือกได้ (ไม่มี '9')
// ALL      = ค่าที่แสดงผล/กรองได้ (มี '9')
export const SHIPPING_STATUS_SETTABLE = ['1', '2', '3', '4', '5'];
export const SHIPPING_STATUS_ALL = ['1', '2', '3', '4', '5', '9'];

export const SHIPPING_STATUS_REQUIRE_REASON = ['4', '5'];

// reward_type ที่มีการจัดส่งจริง e-coupon ('1') ไม่มี
export const SHIPPABLE_REWARD_TYPE = ['2', '3'];

export const REASON_MAX_LENGTH = 500;

// จำนวนรายการสูงสุดต่อการอัปโหลดหนึ่งครั้ง ต้องตรงกับ BULK_MAX_ITEMS ฝั่ง backend
export const BULK_MAX_ITEMS = 1000;

// ตัวเลือกใน modal แก้สถานะ - ไม่มี '9'
export const SHIPPING_STATUS_OPTIONS = SHIPPING_STATUS_SETTABLE.map((value) => ({
  value,
  label: SHIPPING_STATUS_LABEL[value],
}));

// ตัวเลือกใน filter - มี '9' เพื่อให้ดูรายการก่อนเปิดระบบได้
export const SHIPPING_STATUS_FILTER_OPTIONS = [
  { label: 'All', value: '' },
  ...SHIPPING_STATUS_ALL.map((value) => ({
    value,
    label: SHIPPING_STATUS_LABEL[value],
  })),
];

// ต้องรับ rewardType ด้วยเสมอ ไม่งั้น e-coupon จะขึ้น "รอดำเนินการจัดส่ง"
// ทั้งที่ไม่มีการจัดส่ง และทำให้ยอดงานค้างพองเกินจริง
export const RENDER_SHIPPING_STATUS = (value, rewardType) => {
  if (SHIPPABLE_REWARD_TYPE.indexOf(rewardType) === -1) return '';
  // ข้อมูลเก่าที่ไม่มีค่า ถือเป็น 'รอดำเนินการจัดส่ง'
  return SHIPPING_STATUS_LABEL[value || SHIPPING_STATUS.PENDING] || '';
};

// ค่าที่ใช้เทียบ conflict / no-op ต้อง normalize ให้เหมือนฝั่ง backend
export const CURRENT_SHIPPING_STATUS = (value) =>
  value || SHIPPING_STATUS.PENDING;

// ตัดช่องว่างซ้ำและอักขระล่องหนที่มักติดมาจากการ copy-paste
export const CLEAN_CELL = (raw) =>
  String(raw == null ? '' : raw)
    .replace(/[​-‍﻿]/g, '')
    .replace(/\s+/g, ' ')
    .trim();

// รับได้ทั้งรหัส ('3') และป้ายภาษาไทย ('จัดส่งสำเร็จ') ตอนอ่านไฟล์ที่ผู้ใช้กรอกมา
// คืน '' ถ้าไม่ตรงกับค่าที่ตั้งได้ (เพื่อให้ผู้เรียกไปแจ้ง error ต่อ)
// '9' ตั้งไม่ได้ จึงไม่ถูกจับคู่ที่นี่ด้วย
export const PARSE_SHIPPING_STATUS = (raw) => {
  const text = CLEAN_CELL(raw);
  if (!text) return '';
  if (SHIPPING_STATUS_SETTABLE.indexOf(text) > -1) return text;
  const compact = text.replace(/\s/g, '');
  const hit = SHIPPING_STATUS_SETTABLE.find(
    (key) => SHIPPING_STATUS_LABEL[key].replace(/\s/g, '') === compact
  );
  return hit || '';
};
